export const SET_SAGA_CNAE = "deca.SET_SAGA_CNAE";
export const SET_CNAE = "deca.SET_CNAE";

export const ADD_SAGA_CNAE = "deca.ADD_SAGA_CNAE";
export const ADD_CNAE = "deca.ADD_CNAE";

export const DELETE_SAGA_CNAE = "deca.DELETE_SAGA_CNAE";
export const DELETE_CNAE = "deca.DELETE_CNAE";

export const MAIN_SAGA_CNAE = "deca.MAIN_SAGA_CNAE";
export const MAIN_CNAE = "deca.MAIN_CNAE";

export const LOAD_IDS_CNAE = "deca.LOAD_IDS_CNAE";
export const ON_CHANGE_CNAE = "deca.ON_CHANGE_CNAE";
export const ADICIONA_AUTOMATICAMENTE_ATIVIDADE = 'deca.ADICIONA_AUTOMATICAMENTE_ATIVIDADE';
